export default {
  GET_REDIRECT_PAGE_INFO: '/share/get_share_path', // 获取落地页面信息
};
